import { ApiService } from "./api.service";

export default class StatusService extends ApiService {
  namespace = "status";
  icon = "Lightning";
  name = "status";
  favicon = "Lightning";
  window = 290;
  Width = 690;
  realm = 3;
  DOMAIN = 4;
  action = "action";
  singular = this.terminology.status.singular;
  plural = this.terminology.status.plural;
  vowel = this.terminology.status.vowel;

  constructor() {
    super("types");
  }
}
